import { render } from "./ScenarioComparison.vue?vue&type=template&id=81857d4a&scoped=true"
import script from "./ScenarioComparison.vue?vue&type=script&lang=js"
export * from "./ScenarioComparison.vue?vue&type=script&lang=js"

import "./ScenarioComparison.vue?vue&type=style&index=0&id=81857d4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81857d4a"]])

export default __exports__